import {CountUp} from 'countup.js';
import 'is-in-viewport';

$( function() {
	countUp();
} );

$( window ).scroll( function() {
	setTimeout( function() {
		countUp();
	}, 100 );
} );

function countUp() {
	$( '.block-count' ).each( function() {
		var $this = $( this );

		var count;
		var value = $this.attr( 'data-end-value' );
		var countOptions = {
			decimalPlaces: ($this.attr( 'data-decimal' )) ? 1 : 0,
			duration: 4,
			suffix: $this.attr( 'data-suffix' )
		};

		if ( $this.is( ':in-viewport' ) ) {
			if ( !$this.hasClass( 'counted' ) ) {
				count = new CountUp( $this[ 0 ], value, countOptions );

				if ( !count.error ) {
					count.start();
				} else {
					console.error( count.error );
				}
			}

			$this.addClass( 'counted' );
		}
	} );
}
